{
  "title": "Modifier les rôles",
  "savedTitle": "Rôles enregistrés",
  "saveLabel": "Enregistrer les rôles",
  "savingLabel": "Enregistrement",
  "assigned_one": "{{person}} s'est vu assigner cette formation pour son nouveau rôle :",
  "assigned_other": "{{person}} s'est vu assigner cette formation pour ses nouveaux rôles :",
  "fallbackPerson": "Ce bénévole",
  "fallbackModule": "Module de formation",
  "due": "À faire d'ici le {{date}}",
  "caption": "{{person}} dans l'équipe {{team}}",
  "noRoles": "Cette équipe n'a encore défini aucun rôle.",
  "createRoles": "Créer des rôles"
}
